// src/components/common/StylistIdleLogoutTimer.tsx
//
// Mounts in App.tsx (inside UIProvider + IdleLogoutProvider, outside Routes).
// Renders nothing visible when the idle timer is inactive (client, logged-out,
// or kill-switched). Renders the warning modal when prompted.
import React from 'react';
import { useStylistIdleLogout } from '../../hooks/useStylistIdleLogout';
import InactivityWarningModal from './InactivityWarningModal';

const StylistIdleLogoutTimer: React.FC = () => {
  const { showWarning, remainingMs, onStaySignedIn } = useStylistIdleLogout();

  return (
    <InactivityWarningModal
      open={showWarning}
      remainingMs={remainingMs}
      onStaySignedIn={onStaySignedIn}
    />
  );
};

export default StylistIdleLogoutTimer;
